import React from "react";
import { ButtonBar, Carousel } from "@witbooking/react-components";

import styled from "styled-components";

const Container = styled.div``;

export const Grid = styled.div`
  display: flex;
`;

export const Item = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ContainerCarouselStyled = styled.div`
  border: 1px solid #e1e1e1;
  height: 31px;
  width: ${props => `calc(100vw - 30px - ${40 * props.itemSize}px)`};
  calc(70vw);
  border-radius: 4px 0px 0px 4px;
  div > div .slick-prev .NavigateBeforeSVG svg{
    margin-top: 8px;
    fill: #E1E1E1 !important
    width: 32px !important;
    height: 30px !important;
  }
  div > div .slick-next .NavigateNextSVG svg{
    margin-top: 8px;
    fill: #E1E1E1 !important
    width: 32px !important;
    height: 30px !important;
  }
`;

const ContainerItemStyled = styled.div`
  margin: 2px 0px;
  padding: 0px 36px;
  display: flex !important;
  color: #908f96;
  justify-content: center;
  text-overflow: ellipsis;
`;

const ItemStyled = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  max-width: 45vw;
`;

const IconStyled = styled.div`
  svg {
    fill: #908F96
    width: 20px;
    height: 20px;
  }
`;

const ButtonBarOrCarousel = ({
  carousel,
  propertyPromotions,
  onOpenPromotions,
  buttonBarList,
  className,
}) =>
  carousel ? (
    <Grid>
      <Item>
        <ContainerCarouselStyled itemSize={buttonBarList.length}>
          <Carousel autoplay infinite autoplaySpeed={5000} speed={1000}>
            {propertyPromotions.map(promotion => {
              return (
                <ContainerItemStyled onClick={onOpenPromotions}>
                  <ItemStyled dangerouslySetInnerHTML={{ __html: `${promotion?.name}` }} />
                </ContainerItemStyled>
              );
            })}
          </Carousel>
        </ContainerCarouselStyled>
      </Item>
      <Item>{<ButtonBar buttonList={buttonBarList} />}</Item>
    </Grid>
  ) : (
    <Container className={`${className} wbkv9-RoomSelection-EngineButtonBar`}>
      <ButtonBar buttonList={buttonBarList} />
    </Container>
  );

export default ButtonBarOrCarousel;
